export default __webpack_public_path__ + "static/media/img_01.04a77643.jpg";